import React from "react";
import { useController } from "react-hook-form";
import { PatternFormat, PatternFormatProps } from "react-number-format";
import { usePrefixedFieldName } from "shared/components/form/FormFieldPrefix";
import TextInput, {
  TextInputProps,
} from "shared/components/input/text/TextInput";
import { FormInputValue } from "shared/types/FormInputValue";
import { getFieldError } from "shared/utils/FormUtils";

export type PatternInputProps = PatternFormatProps<TextInputProps>;

export const PatternInput = React.forwardRef<
  HTMLInputElement,
  PatternInputProps
>((props, ref) => (
  <PatternFormat customInput={TextInput} getInputRef={ref} {...props} />
));
PatternInput.displayName = "PatternInput";

export type FormPatternInputProps = Omit<
  PatternInputProps,
  | "name"
  | "value"
  | "error"
  | "onChangeValue"
  | "onChange"
  | "type"
  | "valueType"
> & {
  name: string;
};

export const FormPatternInput: React.FC<FormPatternInputProps> = ({
  name,
  isDisabled,
  ...otherProps
}) => {
  const prefixedName = usePrefixedFieldName(name);
  const {
    field: { value, onChange, ...field },
    formState: { errors },
  } = useController<{ text: FormInputValue }>({
    name: prefixedName as "text",
    shouldUnregister: true,
    defaultValue: "",
  });
  return (
    <PatternInput
      {...field}
      {...otherProps}
      value={value}
      valueIsNumericString={true}
      onValueChange={({ value }) => onChange(value)}
      isDisabled={isDisabled}
      error={getFieldError(errors, prefixedName)?.message}
    />
  );
};
